export enum MarketingStatusColour {
  Draft = 'text-slate-300',
  Warning = 'text-amber-500',
  Success = 'text-primary-500',
  Error = 'text-warn-500',
}

export enum MarketingStatusIcon {
  Unknown = 'circle',
  Payment = 'paid',
  Pending = 'pending',
  Running = 'play_circle',
  Paused = 'pause',
  Complete = 'check_circle',
  Cancelled = 'cancel',
  Skipped = 'skip_next',
  Failed = 'error',
  Exit = 'outbound',
}
